import React from 'react';
import { Link } from 'react-router-dom';
import './CourseLegalDisclaimer.css';

/**
 * Shared education-page legal footer.
 * WHY: sales pages need a clear, thorough not-investment-advice block with
 * real policy links. A one-line disclaimer next to the sticky CTA is too thin.
 */
const CourseLegalDisclaimer = ({
  subject = 'This course',
}) => (
  <aside className="cp-disclaimer" data-testid="course-legal-disclaimer">
    <p>
      BotSpot (Lumiwealth) is not a registered investment advisor, broker-dealer,
      or financial planner. {subject} is educational only. Nothing on this page
      is investment advice, a solicitation, or a recommendation to buy, sell, or
      hold any security, cryptocurrency, option, future, or other financial instrument.
    </p>
    <p>
      Trading and investing involve a substantial risk of loss and are not suitable
      for everyone. You can lose some or all of the money you put at risk. Past
      performance, backtests, examples, case studies, and student stories do not
      guarantee future results. BotSpot does not promise profits, income, or any
      particular outcome from taking this course or using the platform.
    </p>
    <p>
      You are solely responsible for your own research, decisions, and trades.
      Before you trade or invest, consider your goals, experience, and risk
      tolerance, and consult a qualified professional if you need advice.
      Enrollment and use of BotSpot are governed by our{' '}
      <Link to="/terms">Terms of Service</Link>
      {' '}and{' '}
      <Link to="/privacy">Privacy Policy</Link>.
    </p>
  </aside>
);

export default CourseLegalDisclaimer;
